<template>
  <sg-tooltip
    ref="tooltipRef"
    v-bind="$attrs"
    trigger="click"
    theme="light"
    popper-class="sg-popover"
    :popper-style="style"
    :transfer="transfer"
    :fallback-placements="['bottom', 'top', 'right', 'left']"
    :hide-after="hideAfter"
    persistent
  >
    <template #content>
      <div class="sg-popconfirm">
        <div class="sg-popconfirm__main">
          <sg-icon
            v-if="!hideIcon && icon"
            class="sg-popconfirm__icon"
            :style="{ color: iconColor }"
          >
            <component :is="icon" />
          </sg-icon>
          {{ title }}
        </div>
        <div class="sg-popconfirm__action">
          <sg-button
            size="small"
            :type="cancelButtonType === 'text' ? '' : cancelButtonType"
            :text="cancelButtonType === 'text'"
            @click="cancel"
          >
            {{ finalCancelButtonText }}
          </sg-button>
          <sg-button
            size="small"
            :type="confirmButtonType === 'text' ? '' : confirmButtonType"
            :text="confirmButtonType === 'text'"
            @click="confirm"
          >
            {{ finalConfirmButtonText }}
          </sg-button>
        </div>
      </div>
    </template>
    <template v-if="$slots.reference">
      <slot name="reference" />
    </template>
  </sg-tooltip>
</template>

<script lang="ts">
import { defineComponent, ref, computed, unref } from 'vue'
import SgButton from '@sgui-plus/components/button'
import SgIcon from '@sgui-plus/components/icon'
import SgTooltip from '@sgui-plus/components/tooltip'
import { popconfirmProps } from './popconfirm'
import { isString } from '@vue/shared'
import { isNumber } from '@vueuse/core'

export default defineComponent({
  name: 'SgPopconfirm',

  components: {
    SgButton,
    SgTooltip,
    SgIcon,
  },

  props: popconfirmProps,

  setup(props) {
    const tooltipRef = ref<{ onClose: () => void }>()

    const hidePopper = () => {
      unref(tooltipRef)?.onClose?.()
    }

    const style = computed(() => {
      if (isString(props.width)) {
        return {
          width: props.width,
        }
      }
      else if (isNumber(props.width)) {
        return {
          width: `${props.width}px`,
        }
      }
    })

    const handleCallback = () => {
      hidePopper()
    }

    const confirm = (e: Event) => {
      props.onConfirm?.(e)
      handleCallback()
    }
    const cancel = (e: Event) => {
      props.onCancel?.(e)
      handleCallback()
    }

    const finalConfirmButtonText = computed(
      () => props.confirmButtonText || '确认'
    )
    const finalCancelButtonText = computed(
      () => props.cancelButtonText || '取消'
    )

    return {
      finalConfirmButtonText,
      finalCancelButtonText,
      tooltipRef,
      style,

      confirm,
      cancel,
    }
  },
})
</script>
